import { useAuthStore } from "src/auth/store/auth.store";
import DashboardLayout from "src/layouts/dashboard";
import RankingView from "./ranking";
import PublicRankingView from "./public-ranking";

// ----------------------------------------------------------------------

export default function RankingWrapper() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return (
      <DashboardLayout>
        <RankingView />
      </DashboardLayout>
    );
  }

  return <PublicRankingView />;
}
